import styled from 'styled-components'

export const NavBarLinks = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-start;
    height: 100%;
`
